module.exports = __webpack_public_path__ + "src/assets/textures/env/trash_bin/transparent_cover_512_bake.png";